import { RefObject, useEffect } from "react";

type RefType = RefObject<HTMLElement> | RefObject<HTMLElement>[]; // Union type for single or array

export const useClickOutside = (refs: RefType, callback: () => void): void => {
    useEffect(() => {
        const clickHandler = (event: MouseEvent): void => {
            // Normalize refs into an array
            const refArray = Array.isArray(refs) ? refs : [refs];

            // Check if the click happened outside all the refs
            const isOutside = refArray.every(ref => ref.current && !ref.current.contains(event.target as Node));
            if (isOutside) {
                callback();
            }
        };

        document.addEventListener("mousedown", clickHandler);

        return () => {
            document.removeEventListener("mousedown", clickHandler);
        };
    }, [refs, callback]);
};
